import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { SizeType } from '@dxp/core/models';
import { ChannelType, QueueMediaType } from '@dxp/core/types';

@Component({
    selector: 'telxl-media-tag',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './media-tag.component.html',
    styleUrls: ['./media-tag.component.scss'],
    host: {
        '[class]': 'class || ""',
    },
})
export class TelXLMediaTagComponent {
    media = input.required<QueueMediaType | ChannelType>();
    fill = input<'normal' | 'outline' | 'filled'>('normal');
    size = input<SizeType>('md');

    font = computed<string>(() => `font-${this.size()}`);

    mediaTypeIcon = computed<string>(() => {
        switch (this.media()) {
            case 'Voice':
            case 'voice':
                return 'fa-solid fa-phone';
            case 'Email':
            case 'email':
                return 'fa-solid fa-envelope';
            case 'Webchat':
            case 'webchat':
                return 'fa-solid fa-message-lines';
            case 'Socials':
                return 'fa-solid fa-share-nodes';
            case 'facebook':
                return 'fa-brands fa-facebook-f';
            case 'instagram':
                return 'fa-brands fa-instagram';
            case 'whatsapp':
                return 'fa-brands fa-whatsapp';
            case 'twitter':
                return 'fa-brands fa-twitter';
            default:
                return 'fa-solid fa-square-check';
        }
    });

    mediaTypeText = computed<string>(() => {
        switch (this.media()) {
            case 'Voice':
            case 'voice':
                return 'text-success';
            case 'Email':
            case 'email':
                return 'text-email';
            case 'Webchat':
            case 'webchat':
                return 'text-webchat';
            case 'Socials':
                return 'text-socials';
            case 'facebook':
                return 'text-facebook';
            case 'instagram':
                return 'text-instagram';
            case 'whatsapp':
                return 'text-whatsapp';
            case 'twitter':
                return 'text-twitter';
            default:
                return 'text-primary';
        }
    });

    mediaTypeBorder = computed<string>(() => {
        switch (this.media()) {
            case 'Voice':
            case 'voice':
                return 'border-success';
            case 'Email':
            case 'email':
                return 'border-email';
            case 'Webchat':
            case 'webchat':
                return 'border-webchat';
            case 'Socials':
                return 'border-socials';
            case 'facebook':
                return 'border-facebook';
            case 'instagram':
                return 'border-instagram';
            case 'whatsapp':
                return 'border-whatsapp';
            case 'twitter':
                return 'border-twitter';
            default:
                return 'border-primary';
        }
    });

    mediaTypeFilled = computed<string>(() => {
        switch (this.media()) {
            case 'Voice':
            case 'voice':
                return 'text-bg-success';
            case 'Email':
            case 'email':
                return 'text-bg-email';
            case 'Webchat':
            case 'webchat':
                return 'text-bg-webchat';
            case 'Socials':
                return 'text-bg-socials';
            case 'facebook':
                return 'text-bg-facebook';
            case 'instagram':
                return 'text-bg-instagram';
            case 'whatsapp':
                return 'text-bg-whatsapp';
            case 'twitter':
                return 'text-bg-twitter';
            default:
                return 'text-bg-primary';
        }
    });
}
